import React, { useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Toolbar from "@material-ui/core/Toolbar";
import { useOktaAuth } from "@okta/okta-react";
import { headerStyles } from "./HeaderStyles";
import { DynamicBreadCrumbs } from "components/Breadcrumbs/DynamicBreadCrumbs";
import { ButtonBase, Typography } from "@material-ui/core";
import { LynxDropdown } from "components/LynxDropdown/LynxDropdown";
import { useStore } from "store/StoreConfigs";
import { observer } from "mobx-react";

export const Header = observer(function Header() {
    const { oktaAuth } = useOktaAuth();
    const { identityStore } = useStore();

    const classes = headerStyles();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const isMenuOpen = Boolean(anchorEl);

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const logout = async () => {
        try {
            await oktaAuth.signOut({ postLogoutRedirectUri: `${window.location.origin}/login` });
        } catch (error) {
            console.log("Error signing out", error);
        }
    };

    const menuId = "primary-search-account-menu";

    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleMenuClose}>General Settings</MenuItem>
            <MenuItem onClick={handleMenuClose}>Notifications</MenuItem>
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose}>Accessability</MenuItem>
            <MenuItem style={{ color: "red" }} onClick={logout}>
                Log out
            </MenuItem>
        </Menu>
    );

    return (
        <div className={classes.grow}>
            <Toolbar className={classes.main}>
                <DynamicBreadCrumbs />
                <div className={classes.grow} />

                {identityStore.isGlobalUser ? (
                    <LynxDropdown
                        isCustomizable={false}
                        options={identityStore.allCustomers.map((x) => x.name)}
                        title="Select customer"
                        optionState={[identityStore.currentCustomer?.name!]}
                        multiple={false}
                        stateSetMethod={(e) => identityStore.setCurrentCustomerByName(e.target.value as string)}
                        customClass={classes.customerDropdown}
                    />
                ) : (
                    <Typography className={classes.userName}>
                        Customer
                        <Typography className={classes.userEmail}>{identityStore.currentCustomer?.name}</Typography>
                    </Typography>
                )}
                <ButtonBase
                    className={classes.profileButton}
                    onClick={handleProfileMenuOpen}
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                >
                    LX
                </ButtonBase>
            </Toolbar>

            {renderMenu}
        </div>
    );
});
